/* eslint-disable @repo/internal/react/require-jsdoc */
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import AsyncSelect from '@atlaskit/react-select/async';
import createSelect from './createSelect';
const packageName = "@atlaskit/select";
const packageVersion = "18.5.0";
export const SelectWithoutAnalytics = createSelect(AsyncSelect);
const createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
const Select = withAnalyticsContext({
  componentName: 'select',
  packageName,
  packageVersion
})(withAnalyticsEvents({
  onChange: createAndFireEventOnAtlaskit({
    action: 'changed',
    actionSubject: 'option',
    attributes: {
      componentName: 'select',
      packageName,
      packageVersion
    }
  })
})(SelectWithoutAnalytics));
export default Select;